import { useState, type ReactNode, useCallback } from 'react';
import {
  ToastContext,
  type Toast,
  type ToastPosition,
  type ToastType
} from './ToastContextBase';

export type { Toast, ToastPosition, ToastType } from './ToastContextBase';

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const [position, setPosition] = useState<ToastPosition>('bottom-right');

  const removeToast = useCallback((id: string) => {
    setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
  }, []);

  const notify = useCallback(
    (
      type: ToastType,
      message: string,
      position?: ToastPosition,
      duration: number = 5000
    ) => {
      const id = `toast-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

      const newToast: Toast = {
        id,
        type,
        message,
        createdAt: Date.now(),
        position: position || 'bottom-right',
        duration
      };

      setToasts(currentToasts => [...currentToasts, newToast]);

      // Auto-remove toast after the specified duration
      setTimeout(() => {
        removeToast(id);
      }, duration);
    },
    [removeToast]
  );

  return (
    <ToastContext.Provider
      value={{ toasts, notify, removeToast, position, setPosition }}
    >
      {children}
    </ToastContext.Provider>
  );
}
